// @generated by protoc-gen-connect-es v0.13.0 with parameter "target=ts"
// @generated from file pharmacy.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Empty, MethodKind } from "@bufbuild/protobuf";
import { GenerateAuthTokenRequest, GenerateAuthTokenResponse } from "./auth/generate_auth_token_pb.js";
import { GetUserAccessRequest, GetUserAccessResponse } from "./auth/get_user_access_pb.js";
import { RefreshTokenRequest, RefreshTokenResponse } from "./auth/refresh_token_pb.js";
import { GetPharmacyInfoRequest, GetPharmacyInfoResponse } from "./auth/get_pharmacy_info_pb.js";
import { ChangeUserPasswordRequest, ChangeUserPasswordResponse, ForgotPasswordRequest, ForgotPasswordResponse, ResetPasswordRequest, ResetPasswordResponse } from "./auth/change_password_pb.js";
import { CreatePatientRequest, CreatePatientResponse } from "./patients/create_patient_pb.js";
import { UpdatePatientRequest, UpdatePatientResponse } from "./patients/update_patient_pb.js";
import { DeletePatientRequest, DeletePatientResponse } from "./patients/delete_patient_pb.js";
import { GetPatientRequest, GetPatientResponse } from "./patients/get_patient_pb.js";
import { ListPatientsRequest, ListPatientsResponse } from "./patients/list_patients_pb.js";
import { CreateDailyItemRequest, CreateDailyItemResponse } from "./dailyitems/create_daily_item_pb.js";
import { UpdateDailyItemRequest, UpdateDailyItemResponse } from "./dailyitems/update_daily_item_pb.js";
import { DeleteDailyItemRequest, DeleteDailyItemResponse } from "./dailyitems/delete_daily_item_pb.js";
import { GetTodayDailyItemRequest, GetTodayDailyItemResponse } from "./dailyitems/get_today_daily_item_pb.js";
import { ListAllDailyItemsRequest, ListAllDailyItemsResponse } from "./dailyitems/list_all_daily_items_pb.js";
import { MarkDailyItemRequest, MarkDailyItemResponse } from "./dailyitems/mark_daily_item_pb.js";
import { UnmarkDailyItemRequest, UnmarkDailyItemResponse } from "./dailyitems/unmark_daily_item_pb.js";
import { StartShiftRequest, StartShiftResponse } from "./shifts/start_shift_pb.js";
import { EndShiftRequest, EndShiftResponse } from "./shifts/end_shift_pb.js";
import { CurrentActiveShiftRequest, CurrentActiveShiftResponse } from "./shifts/current_active_shift_pb.js";
import { EndShiftSystemRequest, EndShiftSystemResponse } from "./shifts/end_shift_system_pb.js";
import { ListShiftsRequest, ListShiftsResponse } from "./shifts/list_shifts_pb.js";
import { ShiftSummaryRequest, ShiftSummaryResponse } from "./shifts/shift_summary_pb.js";
import { AddInventoryRequest, AddInventoryResponse } from "./inventory/add_inventory_pb.js";
import { CreateNonMedicalInventoryPriceRequest, CreateNonMedicalInventoryPriceResponse } from "./inventory/create_non_medical_inventory_price_pb.js";
import { GenerateCustomBarcodeRequest, GenerateCustomBarcodeResponse } from "./inventory/generate_custom_barcode_pb.js";
import { GetInventoryRequest, GetInventoryResponse } from "./inventory/get_inventory_pb.js";
import { GetNonMedicalInventoryPriceHistoryRequest, GetNonMedicalInventoryPriceHistoryResponse } from "./inventory/get_non_medical_inventory_price_history_pb.js";
import { InventoryOverviewRequest, InventoryOverviewResponse } from "./inventory/inventory_overview_pb.js";
import { UpdateInventoryMetadataRequest, UpdateInventoryMetadataResponse } from "./inventory/update_inventory_metadata_pb.js";
import { TransferInventoryRequestRequest, TransferInventoryRequestResponse } from "./inventory/transfer_inventory_request_pb.js";
import { PurchaseActivityRequest, PurchaseActivityResponse } from "./inventory/purchase_activity_pb.js";
import { TransferHistoryRequest, TransferHistoryResponse } from "./inventory/transfer_history_pb.js";
import { ChangeTransferStatusRequest, ChangeTransferStatusResponse } from "./inventory/change_transfer_status_pb.js";
import { StockMovementReportRequest, StockMovementReportResponse } from "./inventory/stock_movement_report_pb.js";
import { InventoryLedgerRequest, InventoryLedgerResponse } from "./inventory/inventory_ledger_pb.js";
import { InventoryStockPointSplitRequest, InventoryStockPointSplitResponse } from "./inventory/inventory_stock_point_split_pb.js";
import { InventoryBranchSplitRequest, InventoryBranchSplitResponse } from "./inventory/inventory_branch_split_pb.js";
import { GetMasterInventoryRequest, GetMasterInventoryResponse } from "./inventory/get_master_inventory_pb.js";
import { AcceptPricingAllRequest, AcceptPricingAllResponse } from "./medical_master/accept_pricing_all_pb.js";
import { AcceptPricingOneRequest, AcceptPricingOneResponse } from "./medical_master/accept_pricing_one_pb.js";
import { GetMedicalMasterRequest, GetMedicalMasterResponse } from "./medical_master/get_medical_master_pb.js";
import { ListMedicalMasterRequest, ListMedicalMasterResponse } from "./medical_master/list_medical_master_pb.js";
import { GetPriceHistoryRequest, GetPriceHistoryResponse } from "./medical_master/get_price_history_pb.js";
import { PricingPendingAcceptanceRequest, PricingPendingAcceptanceResponse } from "./medical_master/pricing_pending_acceptance_pb.js";
import { CreateNonMedicalMasterRequest, CreateNonMedicalMasterResponse } from "./non_medical_master/create_non_medical_master_pb.js";
import { ListNonMedicalMasterRequest, ListNonMedicalMasterResponse } from "./non_medical_master/list_non_medical_master_pb.js";
import { GetNonMedicalMasterRequest, GetNonMedicalMasterResponse } from "./non_medical_master/get_non_medical_master_pb.js";
import { CreatePurchaseInvoiceRequest, CreatePurchaseInvoiceResponse } from "./purchase_invoice/create_purchase_invoice_pb.js";
import { ListPurchaseInvoicesRequest, ListPurchaseInvoicesResponse } from "./purchase_invoice/list_purchase_invoices_pb.js";
import { GetPurchaseInvoiceRequest, GetPurchaseInvoiceResponse } from "./purchase_invoice/get_purchase_invoice_pb.js";
import { MakePaymentRequest, MakePaymentResponse } from "./purchase_invoice/make_payment_pb.js";
import { CreatePurchaseOrderRequest, CreatePurchaseOrderResponse } from "./purchase_order/create_purchase_order_pb.js";
import { ListPurchaseOrdersRequest, ListPurchaseOrdersResponse } from "./purchase_order/list_purchase_orders_pb.js";
import { GetPurchaseOrderRequest, GetPurchaseOrderResponse } from "./purchase_order/get_purchase_order_pb.js";
import { ListPurchaseRequestsRequest, ListPurchaseRequestsResponse } from "./purchase_request/list_purchase_requests_pb.js";
import { GetPurchaseRequestRequest, GetPurchaseRequestResponse } from "./purchase_request/get_purchase_request_pb.js";
import { SearchInventoryRequest, SearchInventoryResponse } from "./search/search_inventory_pb.js";
import { ListSuppliersRequest, ListSuppliersResponse } from "./suppliers/list_suppliers_pb.js";
import { CreateSupplierRequest, CreateSupplierResponse } from "./suppliers/create_supplier_pb.js";
import { GetSupplierRequest, GetSupplierResponse } from "./suppliers/get_supplier_pb.js";
import { CreateSaleRequest, CreateSaleResponse } from "./sales/create_sale_pb.js";
import { GetSaleRequest, GetSaleResponse } from "./sales/get_sale_pb.js";
import { ListSalesRequest, ListSalesResponse } from "./sales/list_sales_pb.js";
import { VoidSaleRequest, VoidSaleResponse } from "./sales/void_sale_pb.js";
import { RefundSaleRequest, RefundSaleResponse } from "./sales/refund_sale_pb.js";
import { DailySalesRequest, DailySalesResponse } from "./sales/daily_sales_pb.js";
import { OverviewReportRequest, OverviewReportResponse } from "./reports/overview_pb.js";
import { RevenueReportRequest, RevenueReportResponse } from "./reports/revenue_pb.js";
import { PLReportRequest, PLReportResponse } from "./reports/pl_report_pb.js";
import { SupplierProfitabilityReportRequest, SupplierProfitabilityReportResponse } from "./reports/supplier_profitability_report_pb.js";
import { ProductProfitabilityReportRequest, ProductProfitabilityReportResponse } from "./reports/product_profitability_report_pb.js";
import { CustomerProfitabilityReportRequest, CustomerProfitabilityReportResponse } from "./reports/customer_profitability_report_pb.js";
import { SalesPerItemReportRequest, SalesPerItemReportResponse } from "./reports/sales_per_item_report_pb.js";
import { SlowMovingItemsReportRequest, SlowMovingItemsReportResponse } from "./reports/slow_moving_items_report_pb.js";
import { FastMovingItemsReportRequest, FastMovingItemsReportResponse } from "./reports/fast_moving_items_report_pb.js";
import { ItemSalesVelocityReportRequest, ItemSalesVelocityReportResponse } from "./reports/item_sales_velocity_report_pb.js";
import { ItemsToReorderReportRequest, ItemsToReorderReportResponse } from "./reports/items_to_reorder_report_pb.js";
import { GetStockPointsRequest, GetStockPointsResponse } from "./branch/get_stock_points_pb.js";
import { CreateNewStockPointRequest, CreateNewStockPointResponse } from "./branch/create_new_stock_point_pb.js";
import { AccountsCogsRequest, AccountsCogsResponse } from "./accounts/accounts_cogs_pb.js";
import { AccountsRevenueRequest, AccountsRevenueResponse } from "./accounts/accounts_revenue_pb.js";
import { AccountsPLRequest, AccountsPLResponse } from "./accounts/accounts_pl_pb.js";
import { AccountsPaymentMethodBreakdownRequest, AccountsPaymentMethodBreakdownResponse } from "./accounts/accounts_payment_method_breakdown_pb.js";
import { CreatePurchaseReturnRequest, CreatePurchaseReturnResponse } from "./purchase_return/create_purchase_return_pb.js";
import { ListPurchaseReturnsRequest, ListPurchaseReturnsResponse } from "./purchase_return/list_purchase_returns_pb.js";
import { CompletePurchaseReturnRequest, CompletePurchaseReturnResponse } from "./purchase_return/complete_purchase_return_pb.js";
import { ListCreditNotesRequest, ListCreditNotesResponse } from "./purchase_return/list_credit_notes_pb.js";
import { MinMaxAutomationRequest, MinMaxAutomationResponse } from "./automations/min_max_pb.js";
import { UpdateMinMaxRequest, UpdateMinMaxResponse } from "./automations/update_min_max_pb.js";
import { CreateUserRequest, CreateUserResponse, GetUsersInPharmacyRequest, GetUsersInPharmacyResponse } from "./auth/users_pb.js";
import { SwitchContextRequest } from "./auth/switch_context_pb.js";
import { GetBranchesForCompanyRequest, GetBranchesForCompanyResponse } from "./branch/get_branches_pb.js";
import { GetMedicalInventoryStockRequest, GetMedicalInventoryStockResponse } from "./onboarding/get_medical_inventory_stock_pb.js";
import { GetNonMedicalInventoryStockRequest, GetNonMedicalInventoryStockResponse } from "./onboarding/get_non_medical_inventory_stock_pb.js";
import { TransferItemRequest, TransferItemResponse } from "./onboarding/transfer_item_pb.js";
import { UpsertMedicalInventoryRequest, UpsertMedicalInventoryResponse } from "./onboarding/upsert_medical_inventory_pb.js";
import { PharmacyRawDumpRequest } from "./dump/inventory_dump_pb.js";

/**
 * @generated from service com.neulink.pharmacy.PharmacyService
 */
export const PharmacyService = {
  typeName: "com.neulink.pharmacy.PharmacyService",
  methods: {
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.Ping
     */
    ping: {
      name: "Ping",
      I: Empty,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GenerateAuthToken
     */
    generateAuthToken: {
      name: "GenerateAuthToken",
      I: GenerateAuthTokenRequest,
      O: GenerateAuthTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetUserAccess
     */
    getUserAccess: {
      name: "GetUserAccess",
      I: GetUserAccessRequest,
      O: GetUserAccessResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.RefreshToken
     */
    refreshToken: {
      name: "RefreshToken",
      I: RefreshTokenRequest,
      O: RefreshTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetPharmacyInfo
     */
    getPharmacyInfo: {
      name: "GetPharmacyInfo",
      I: GetPharmacyInfoRequest,
      O: GetPharmacyInfoResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ChangeUserPassword
     */
    changeUserPassword: {
      name: "ChangeUserPassword",
      I: ChangeUserPasswordRequest,
      O: ChangeUserPasswordResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ForgotPassword
     */
    forgotPassword: {
      name: "ForgotPassword",
      I: ForgotPasswordRequest,
      O: ForgotPasswordResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ResetPassword
     */
    resetPassword: {
      name: "ResetPassword",
      I: ResetPasswordRequest,
      O: ResetPasswordResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CreatePatient
     */
    createPatient: {
      name: "CreatePatient",
      I: CreatePatientRequest,
      O: CreatePatientResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.UpdatePatient
     */
    updatePatient: {
      name: "UpdatePatient",
      I: UpdatePatientRequest,
      O: UpdatePatientResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.DeletePatient
     */
    deletePatient: {
      name: "DeletePatient",
      I: DeletePatientRequest,
      O: DeletePatientResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetPatient
     */
    getPatient: {
      name: "GetPatient",
      I: GetPatientRequest,
      O: GetPatientResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ListPatients
     */
    listPatients: {
      name: "ListPatients",
      I: ListPatientsRequest,
      O: ListPatientsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateDailyItem
     */
    createDailyItem: {
      name: "CreateDailyItem",
      I: CreateDailyItemRequest,
      O: CreateDailyItemResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.UpdateDailyItem
     */
    updateDailyItem: {
      name: "UpdateDailyItem",
      I: UpdateDailyItemRequest,
      O: UpdateDailyItemResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.DeleteDailyItem
     */
    deleteDailyItem: {
      name: "DeleteDailyItem",
      I: DeleteDailyItemRequest,
      O: DeleteDailyItemResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetTodayDailyItem
     */
    getTodayDailyItem: {
      name: "GetTodayDailyItem",
      I: GetTodayDailyItemRequest,
      O: GetTodayDailyItemResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ListAllDailyItems
     */
    listAllDailyItems: {
      name: "ListAllDailyItems",
      I: ListAllDailyItemsRequest,
      O: ListAllDailyItemsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.MarkDailyItem
     */
    markDailyItem: {
      name: "MarkDailyItem",
      I: MarkDailyItemRequest,
      O: MarkDailyItemResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.UnmarkDailyItem
     */
    unmarkDailyItem: {
      name: "UnmarkDailyItem",
      I: UnmarkDailyItemRequest,
      O: UnmarkDailyItemResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.StartShift
     */
    startShift: {
      name: "StartShift",
      I: StartShiftRequest,
      O: StartShiftResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.EndShift
     */
    endShift: {
      name: "EndShift",
      I: EndShiftRequest,
      O: EndShiftResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CurrentActiveShift
     */
    currentActiveShift: {
      name: "CurrentActiveShift",
      I: CurrentActiveShiftRequest,
      O: CurrentActiveShiftResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.EndShiftSystem
     */
    endShiftSystem: {
      name: "EndShiftSystem",
      I: EndShiftSystemRequest,
      O: EndShiftSystemResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ListShifts
     */
    listShifts: {
      name: "ListShifts",
      I: ListShiftsRequest,
      O: ListShiftsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ShiftSummary
     */
    shiftSummary: {
      name: "ShiftSummary",
      I: ShiftSummaryRequest,
      O: ShiftSummaryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.AddInventory
     */
    addInventory: {
      name: "AddInventory",
      I: AddInventoryRequest,
      O: AddInventoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateNonMedicalInventoryPrice
     */
    createNonMedicalInventoryPrice: {
      name: "CreateNonMedicalInventoryPrice",
      I: CreateNonMedicalInventoryPriceRequest,
      O: CreateNonMedicalInventoryPriceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GenerateCustomBarcode
     */
    generateCustomBarcode: {
      name: "GenerateCustomBarcode",
      I: GenerateCustomBarcodeRequest,
      O: GenerateCustomBarcodeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetInventory
     */
    getInventory: {
      name: "GetInventory",
      I: GetInventoryRequest,
      O: GetInventoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetNonMedicalInventoryPriceHistory
     */
    getNonMedicalInventoryPriceHistory: {
      name: "GetNonMedicalInventoryPriceHistory",
      I: GetNonMedicalInventoryPriceHistoryRequest,
      O: GetNonMedicalInventoryPriceHistoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.InventoryOverview
     */
    inventoryOverview: {
      name: "InventoryOverview",
      I: InventoryOverviewRequest,
      O: InventoryOverviewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.UpdateInventoryMetadata
     */
    updateInventoryMetadata: {
      name: "UpdateInventoryMetadata",
      I: UpdateInventoryMetadataRequest,
      O: UpdateInventoryMetadataResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.TransferInventoryRequest
     */
    transferInventoryRequest: {
      name: "TransferInventoryRequest",
      I: TransferInventoryRequestRequest,
      O: TransferInventoryRequestResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.PurchaseActivity
     */
    purchaseActivity: {
      name: "PurchaseActivity",
      I: PurchaseActivityRequest,
      O: PurchaseActivityResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.TransferHistory
     */
    transferHistory: {
      name: "TransferHistory",
      I: TransferHistoryRequest,
      O: TransferHistoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ChangeTransferStatus
     */
    changeTransferStatus: {
      name: "ChangeTransferStatus",
      I: ChangeTransferStatusRequest,
      O: ChangeTransferStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.StockMovementReport
     */
    stockMovementReport: {
      name: "StockMovementReport",
      I: StockMovementReportRequest,
      O: StockMovementReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.InventoryLedger
     */
    inventoryLedger: {
      name: "InventoryLedger",
      I: InventoryLedgerRequest,
      O: InventoryLedgerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.InventoryStockPointSplit
     */
    inventoryStockPointSplit: {
      name: "InventoryStockPointSplit",
      I: InventoryStockPointSplitRequest,
      O: InventoryStockPointSplitResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.InventoryBranchSplit
     */
    inventoryBranchSplit: {
      name: "InventoryBranchSplit",
      I: InventoryBranchSplitRequest,
      O: InventoryBranchSplitResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetMasterInventory
     */
    getMasterInventory: {
      name: "GetMasterInventory",
      I: GetMasterInventoryRequest,
      O: GetMasterInventoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.AcceptPricingAll
     */
    acceptPricingAll: {
      name: "AcceptPricingAll",
      I: AcceptPricingAllRequest,
      O: AcceptPricingAllResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.AcceptPricingOne
     */
    acceptPricingOne: {
      name: "AcceptPricingOne",
      I: AcceptPricingOneRequest,
      O: AcceptPricingOneResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetMedicalMaster
     */
    getMedicalMaster: {
      name: "GetMedicalMaster",
      I: GetMedicalMasterRequest,
      O: GetMedicalMasterResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ListMedicalMaster
     */
    listMedicalMaster: {
      name: "ListMedicalMaster",
      I: ListMedicalMasterRequest,
      O: ListMedicalMasterResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetPriceHistory
     */
    getPriceHistory: {
      name: "GetPriceHistory",
      I: GetPriceHistoryRequest,
      O: GetPriceHistoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.PricingPendingAcceptance
     */
    pricingPendingAcceptance: {
      name: "PricingPendingAcceptance",
      I: PricingPendingAcceptanceRequest,
      O: PricingPendingAcceptanceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateNonMedicalMaster
     */
    createNonMedicalMaster: {
      name: "CreateNonMedicalMaster",
      I: CreateNonMedicalMasterRequest,
      O: CreateNonMedicalMasterResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ListNonMedicalMaster
     */
    listNonMedicalMaster: {
      name: "ListNonMedicalMaster",
      I: ListNonMedicalMasterRequest,
      O: ListNonMedicalMasterResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetNonMedicalMaster
     */
    getNonMedicalMaster: {
      name: "GetNonMedicalMaster",
      I: GetNonMedicalMasterRequest,
      O: GetNonMedicalMasterResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CreatePurchaseInvoice
     */
    createPurchaseInvoice: {
      name: "CreatePurchaseInvoice",
      I: CreatePurchaseInvoiceRequest,
      O: CreatePurchaseInvoiceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ListPurchaseInvoices
     */
    listPurchaseInvoices: {
      name: "ListPurchaseInvoices",
      I: ListPurchaseInvoicesRequest,
      O: ListPurchaseInvoicesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetPurchaseInvoice
     */
    getPurchaseInvoice: {
      name: "GetPurchaseInvoice",
      I: GetPurchaseInvoiceRequest,
      O: GetPurchaseInvoiceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.MakePayment
     */
    makePayment: {
      name: "MakePayment",
      I: MakePaymentRequest,
      O: MakePaymentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CreatePurchaseOrder
     */
    createPurchaseOrder: {
      name: "CreatePurchaseOrder",
      I: CreatePurchaseOrderRequest,
      O: CreatePurchaseOrderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ListPurchaseOrders
     */
    listPurchaseOrders: {
      name: "ListPurchaseOrders",
      I: ListPurchaseOrdersRequest,
      O: ListPurchaseOrdersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetPurchaseOrder
     */
    getPurchaseOrder: {
      name: "GetPurchaseOrder",
      I: GetPurchaseOrderRequest,
      O: GetPurchaseOrderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ListPurchaseRequests
     */
    listPurchaseRequests: {
      name: "ListPurchaseRequests",
      I: ListPurchaseRequestsRequest,
      O: ListPurchaseRequestsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetPurchaseRequest
     */
    getPurchaseRequest: {
      name: "GetPurchaseRequest",
      I: GetPurchaseRequestRequest,
      O: GetPurchaseRequestResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.SearchInventory
     */
    searchInventory: {
      name: "SearchInventory",
      I: SearchInventoryRequest,
      O: SearchInventoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ListSuppliers
     */
    listSuppliers: {
      name: "ListSuppliers",
      I: ListSuppliersRequest,
      O: ListSuppliersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateSupplier
     */
    createSupplier: {
      name: "CreateSupplier",
      I: CreateSupplierRequest,
      O: CreateSupplierResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetSupplier
     */
    getSupplier: {
      name: "GetSupplier",
      I: GetSupplierRequest,
      O: GetSupplierResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateSale
     */
    createSale: {
      name: "CreateSale",
      I: CreateSaleRequest,
      O: CreateSaleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetSale
     */
    getSale: {
      name: "GetSale",
      I: GetSaleRequest,
      O: GetSaleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ListSales
     */
    listSales: {
      name: "ListSales",
      I: ListSalesRequest,
      O: ListSalesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.VoidSale
     */
    voidSale: {
      name: "VoidSale",
      I: VoidSaleRequest,
      O: VoidSaleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.RefundSale
     */
    refundSale: {
      name: "RefundSale",
      I: RefundSaleRequest,
      O: RefundSaleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.DailySales
     */
    dailySales: {
      name: "DailySales",
      I: DailySalesRequest,
      O: DailySalesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.OverviewReport
     */
    overviewReport: {
      name: "OverviewReport",
      I: OverviewReportRequest,
      O: OverviewReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.RevenueReport
     */
    revenueReport: {
      name: "RevenueReport",
      I: RevenueReportRequest,
      O: RevenueReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.PLReport
     */
    pLReport: {
      name: "PLReport",
      I: PLReportRequest,
      O: PLReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.SupplierProfitabilityReport
     */
    supplierProfitabilityReport: {
      name: "SupplierProfitabilityReport",
      I: SupplierProfitabilityReportRequest,
      O: SupplierProfitabilityReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ProductProfitabilityReport
     */
    productProfitabilityReport: {
      name: "ProductProfitabilityReport",
      I: ProductProfitabilityReportRequest,
      O: ProductProfitabilityReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CustomerProfitabilityReport
     */
    customerProfitabilityReport: {
      name: "CustomerProfitabilityReport",
      I: CustomerProfitabilityReportRequest,
      O: CustomerProfitabilityReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.SalesPerItemReport
     */
    salesPerItemReport: {
      name: "SalesPerItemReport",
      I: SalesPerItemReportRequest,
      O: SalesPerItemReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.SlowMovingItemsReport
     */
    slowMovingItemsReport: {
      name: "SlowMovingItemsReport",
      I: SlowMovingItemsReportRequest,
      O: SlowMovingItemsReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.FastMovingItemsReport
     */
    fastMovingItemsReport: {
      name: "FastMovingItemsReport",
      I: FastMovingItemsReportRequest,
      O: FastMovingItemsReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ItemSalesVelocityReport
     */
    itemSalesVelocityReport: {
      name: "ItemSalesVelocityReport",
      I: ItemSalesVelocityReportRequest,
      O: ItemSalesVelocityReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ItemsToReorderReport
     */
    itemsToReorderReport: {
      name: "ItemsToReorderReport",
      I: ItemsToReorderReportRequest,
      O: ItemsToReorderReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetStockPoints
     */
    getStockPoints: {
      name: "GetStockPoints",
      I: GetStockPointsRequest,
      O: GetStockPointsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateNewStockPoint
     */
    createNewStockPoint: {
      name: "CreateNewStockPoint",
      I: CreateNewStockPointRequest,
      O: CreateNewStockPointResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.AccountsCogs
     */
    accountsCogs: {
      name: "AccountsCogs",
      I: AccountsCogsRequest,
      O: AccountsCogsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.AccountsRevenue
     */
    accountsRevenue: {
      name: "AccountsRevenue",
      I: AccountsRevenueRequest,
      O: AccountsRevenueResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.AccountsPL
     */
    accountsPL: {
      name: "AccountsPL",
      I: AccountsPLRequest,
      O: AccountsPLResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.AccountsPaymentMethodBreakdown
     */
    accountsPaymentMethodBreakdown: {
      name: "AccountsPaymentMethodBreakdown",
      I: AccountsPaymentMethodBreakdownRequest,
      O: AccountsPaymentMethodBreakdownResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CreatePurchaseReturn
     */
    createPurchaseReturn: {
      name: "CreatePurchaseReturn",
      I: CreatePurchaseReturnRequest,
      O: CreatePurchaseReturnResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ListPurchaseReturns
     */
    listPurchaseReturns: {
      name: "ListPurchaseReturns",
      I: ListPurchaseReturnsRequest,
      O: ListPurchaseReturnsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CompletePurchaseReturn
     */
    completePurchaseReturn: {
      name: "CompletePurchaseReturn",
      I: CompletePurchaseReturnRequest,
      O: CompletePurchaseReturnResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.ListCreditNotes
     */
    listCreditNotes: {
      name: "ListCreditNotes",
      I: ListCreditNotesRequest,
      O: ListCreditNotesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.MinMaxAutomation
     */
    minMaxAutomation: {
      name: "MinMaxAutomation",
      I: MinMaxAutomationRequest,
      O: MinMaxAutomationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.UpdateMinMax
     */
    updateMinMax: {
      name: "UpdateMinMax",
      I: UpdateMinMaxRequest,
      O: UpdateMinMaxResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetUsersInPharmacy
     */
    getUsersInPharmacy: {
      name: "GetUsersInPharmacy",
      I: GetUsersInPharmacyRequest,
      O: GetUsersInPharmacyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateUser
     */
    createUser: {
      name: "CreateUser",
      I: CreateUserRequest,
      O: CreateUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.SwitchPharmacyContext
     */
    switchPharmacyContext: {
      name: "SwitchPharmacyContext",
      I: SwitchContextRequest,
      O: GenerateAuthTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetBranchesForCompany
     */
    getBranchesForCompany: {
      name: "GetBranchesForCompany",
      I: GetBranchesForCompanyRequest,
      O: GetBranchesForCompanyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetMedicalInventoryStock
     */
    getMedicalInventoryStock: {
      name: "GetMedicalInventoryStock",
      I: GetMedicalInventoryStockRequest,
      O: GetMedicalInventoryStockResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.GetNonMedicalInventoryStock
     */
    getNonMedicalInventoryStock: {
      name: "GetNonMedicalInventoryStock",
      I: GetNonMedicalInventoryStockRequest,
      O: GetNonMedicalInventoryStockResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.TransferItem
     */
    transferItem: {
      name: "TransferItem",
      I: TransferItemRequest,
      O: TransferItemResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.UpsertMedicalInventoryStock
     */
    upsertMedicalInventoryStock: {
      name: "UpsertMedicalInventoryStock",
      I: UpsertMedicalInventoryRequest,
      O: UpsertMedicalInventoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.neulink.pharmacy.PharmacyService.DumpPharmacyData
     */
    dumpPharmacyData: {
      name: "DumpPharmacyData",
      I: PharmacyRawDumpRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
  }
} as const;

